import { useId, useRef } from "react";
import { C } from "./theme";
import { BottomSheet } from "./BottomSheet";

// A question the user answers before something happens, in the help sheet's design. `confirm` and `cancel`
// are the two buttons' words. Focus starts on cancel, so a stray Enter changes nothing. Escape, cancel and a
// tap outside all call onCancel.
export function ConfirmDialog({ title, body, confirm, cancel, onConfirm, onCancel }) {
  const cancelRef = useRef(null);
  const id = useId();
  const button = { flex: 1, minHeight: 44, borderRadius: C.rsm, padding: "0 16px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" };
  return (
    <BottomSheet role="alertdialog" labelledBy={`${id}-title`} describedBy={body ? `${id}-body` : undefined} startRef={cancelRef} onClose={onCancel}>
      <h2 id={`${id}-title`} style={{ margin: "0 0 8px", fontSize: 17, fontWeight: 700 }}>{title}</h2>
      {body && <p id={`${id}-body`} style={{ margin: 0, fontSize: 16, lineHeight: 1.45, color: C.textMid }}>{body}</p>}
      <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <button ref={cancelRef} onClick={onCancel} style={{ ...button, background: C.surface2, color: C.text, border: `1px solid ${C.border}` }}>{cancel}</button>
        <button onClick={onConfirm} style={{ ...button, background: C.accent, color: C.onAccent, border: "none" }}>{confirm}</button>
      </div>
    </BottomSheet>
  );
}
